module.exports = __webpack_public_path__ + "img/Hummingbird.d21fd066.jpg";